import { useState } from 'react'
import { Button, Spinner } from 'reactstrap'
import { gql } from '@apollo/client'
import { deepCopy } from '../../utils'
import { RESEND_MFA_CODE_MUTATION } from '../../graphql.js'

const RESEND_MFA_CODE =  gql(RESEND_MFA_CODE_MUTATION)

export default function MethodButton(props) {
  console.log('MethodButton rendered: ', props)
  let { loginData, setLoginData } = props

  const [spinner, setSpinner] = useState(false)

  async function resendUsing(newMethod) {
    setSpinner(true)
    await window.apolloClient.mutate({ mutation: RESEND_MFA_CODE, variables: { userId: loginData.id, method: newMethod } })
    setSpinner(false)
    const newLoginData = deepCopy(loginData)
    newLoginData.mfaMethod = newMethod
    setLoginData(newLoginData)
  }

  let buttons = []
  let style = { marginBottom: '5px', display: 'block' }
  if (loginData.mfaMethod === 'EMAIL') {
    if (loginData.cellPhone) {
      buttons.push(<Button color="secondary" style={style} onClick={() => resendUsing('SMS')}>{`Send text message to ${loginData.cellPhone}`}</Button>)
    }
    if (loginData.hasSecret) {
      buttons.push(<Button color="secondary" onClick={() => resendUsing('APP')}>Use Authenticator App</Button>)
    }
  }
  if (loginData.mfaMethod === 'SMS') {
    if (loginData.email) {
      buttons.push(<Button color="secondary" style={style} onClick={() => resendUsing('EMAIL')}>{`Send email to ${loginData.email}`}</Button>)
    }
    if (loginData.hasSecret) {
      buttons.push(<Button color="secondary" onClick={() => resendUsing('APP')}>Use Authenticator App</Button>)
    }
  }
  if (loginData.mfaMethod === 'APP') {
    if (loginData.email) {
      buttons.push(<Button color="secondary" style={style} onClick={() => resendUsing('EMAIL')}>{`Send email to ${loginData.email}`}</Button>)
    }
    if (loginData.cellPhone) {
      buttons.push(<Button color="secondary" onClick={() => resendUsing('SMS')}>{`Send text message to ${loginData.cellPhone}`}</Button>)
    }
  }

  if (spinner) {
    return <Spinner size="sm" color="primary" />
  }
  return (buttons)
}